
import {of as observableOf,  Observable } from 'rxjs';

import {switchMap, take, first} from 'rxjs/operators';
import { Respondent } from './../../../../models/respondent.model';
import { ProcessParticipationService } from './../../../../services/process.participation.service';
import { ModalService } from './../../../../services/modal.service';
import { KnownProcessType, ProcessParticipation, ProcessRespondentSelectionCriterionValue, ProcessRespondentSelectionCriterionType } from './../../../../models/process-models';
import { EnumDescription } from './../../../../helpers/enum-description.helper';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalType } from '../../../../models/modal.type.enum';
import { EmployeeInfo } from '../../../../models/identity';
import { AppraiseeProvider } from '../../../../common/providers/appraisee.provider';
import { CriterionName } from '../../../../helpers/criterion-name-helper';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { AddRespondentComponent } from '../../../../common/modal/add-respondent/add-respondent.component';


@Component({
    selector: 'app-respondent-edit-list',
    templateUrl: './respondent-edit-list.component.html',
    styleUrls: ['./respondent-edit-list.component.scss']
})
export class RespondentEditListComponent implements OnInit {

    @Input() set processParticipators(p: Array<ProcessParticipation>){
      this._processParticipators = p;
      this.filterProcessParticipators();
    }
    @Input() processDurationId: number;
    @Input() isDeleteModalHidden = false;
    @Input() minRespondentAmount;
    @Input() allowSelfAssesment: boolean;
    @Input() respondentSelectionValues: Array<ProcessRespondentSelectionCriterionValue>;
    @Input() knownProcessTypes: Array<KnownProcessType>;
    
    @Output() appraiseeChanged = new EventEmitter<number>();

    isEdit = false;
    pageNumber: number = 1;
    pageSize: number = 10;
    filtredProcessParticipators: Array<ProcessParticipation>;
    searchTimer: any;
    modalRef: BsModalRef;
    _processParticipators: Array<ProcessParticipation> = [];

    private searchKeyword: string = '';
    private selectedProcessParticipator: ProcessParticipation;

    constructor(private bsModalService: BsModalService,
      private modalService: ModalService, private processParticipationService: ProcessParticipationService,
      private readonly appraiseeProvider: AppraiseeProvider) {
        this.modalService.modalVisibilityChanged$
        .subscribe(x => this.isDeleteModalHidden = x);

        this.modalService.modalOkClicked$
          .subscribe(data => {
            if (data.modalType !== ModalType.Delete) { return; }
            if (data.isAppraiseeDeletetion){
              this.deleteAppraisee(data.processDurationAppraiseeId);
            }
            else{
              this.deleteRespondent(data.processDurationAppraiseeId, data.respondentId);
            }
          });
    }

    ngOnInit() {
    }

    search(event: any) {
      this.searchKeyword = event.srcElement.value;
      if(this.searchKeyword.length < 3 && this.searchKeyword.length != 0) {
        return
      }

      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.filterProcessParticipators();
      }, 500);
    }

    async openAddRespondentModal(processParticipator: ProcessParticipation) {
        this.modalRef = this.bsModalService.show(AddRespondentComponent,
            {  initialState: {
                knownProcessTypes: this.knownProcessTypes,
                respondentSelectionValues: this.respondentSelectionValues,
                appraiseeName: this.getAppraiseeName(processParticipator.appraisee),
                processDurationAppraiseeId: processParticipator.processDurationAppraiseeId,
                isOnDraft: true}} as ModalOptions);
        this.bsModalService.onHidden.pipe(first()).subscribe(() => {
            if (!this.modalRef.content.isAdded) return;
            this.addRespondent(this.modalRef.content.addedRespondents, this.modalRef.content.processDurationAppraiseeId);
        });
    }

    filterProcessParticipators(){
      this.filtredProcessParticipators = !!this._processParticipators ? this._processParticipators: [];
      this.filtredProcessParticipators = this.filtredProcessParticipators.filter(p => this.isParticipationFiltred(this.searchKeyword, p));
    }

    changePageNumber(newPageNumber: number){
      this.pageNumber = newPageNumber;
    }

    getMinRespondentsAmount(processParticipation: ProcessParticipation): number {
      return this.allowSelfAssesment && processParticipation.appraisee !== null ? processParticipation.respondents.filter(x => x.id !== processParticipation.appraisee.id).length : 
      processParticipation.respondents.length;
    }

    getRespondentCriterions(respondent: Respondent) : Array<string> {
      return respondent.knownProcessTypes.map(t => CriterionName.GetCriterionName(t, respondent.selectedProcessParticipationSelectionCriterionType));
    }

    deleteAppraisee(processDurationAppraiseeId: number) {
      this.processParticipationService.deleteAppraisee(processDurationAppraiseeId)
        .subscribe(() => {
          this.appraiseeChanged.emit(processDurationAppraiseeId);
          this.modalService.hideModal();
        });
    }

    deleteRespondent(processDurationAppraiseeId: number, respondentId: number) {
      this.processParticipationService.delete(processDurationAppraiseeId, respondentId)
        .pipe(take(1)).subscribe(() => {
          const appraisee = this.getAppraiseeById(processDurationAppraiseeId);       
          const respondentIndexToDelete = appraisee.respondents.findIndex(r => r.id === respondentId);
          appraisee.respondents.splice(respondentIndexToDelete, 1);
          this.modalService.hideModal();
        });
    }

    getProcessTypeDescription(processType: KnownProcessType): string {
        return EnumDescription.GetDescription(KnownProcessType, +processType);
    }

    getRegardingGradeText(respondentGradeLevel: number, appraiseeGradeLevel: number) {
      if (respondentGradeLevel < appraiseeGradeLevel) { return 'Lower grade'; }
      if (respondentGradeLevel > appraiseeGradeLevel) { return 'Higher grade'; }
      return 'Same grade';
    }

    getAppraiseeName(appraisee: EmployeeInfo) {
      return this.appraiseeProvider.getAppraiseeName(appraisee);
    }    
    
    getIsWarning(): boolean {
      return this.minRespondentAmount && this._processParticipators
        ? this._processParticipators.some(pp => pp.respondents.length < this.minRespondentAmount)
        : false;
    }

    getProcessParticipator(processParticipation: ProcessParticipation): Array<Respondent> {
      return this.allowSelfAssesment && processParticipation.appraisee !== null ? processParticipation.respondents.filter(x => processParticipation.appraisee &&
         x.id !== processParticipation.appraisee.id) :
      processParticipation.respondents;
    }

    private isParticipationFiltred(pattern: string, participation: ProcessParticipation) : boolean {
      let names : Array<string> = [];
      if (participation.appraisee){
        names.push(participation.appraisee.name);
      }
      return names.concat(participation.respondents.map(r => r.name)).some(n => n.toLowerCase().startsWith(pattern.toLowerCase()));
    }

    private addRespondent(respondens: Array<Respondent>, processDurationAppraiseeId: number) {
        let addedRespondents: Array<Respondent> = respondens;
        const appraisee = this.getAppraiseeById(processDurationAppraiseeId);
        if (appraisee){
          appraisee.respondents = addedRespondents.concat(appraisee.respondents);
        }

        this.modalService.hideModal();
    }

    private pushSelectedRespondents(processParticipants: ProcessParticipation) {
      this.selectedProcessParticipator = { respondents: [], processDurationAppraiseeId: processParticipants.processDurationAppraiseeId };
      const respondents = this._processParticipators
        .find(a => a.processDurationAppraiseeId === this.selectedProcessParticipator.processDurationAppraiseeId).respondents;
      processParticipants.respondents.forEach(item => {
        const isSelectedAlreadyInList = respondents.some(r => r.id === item.id);
        if (!isSelectedAlreadyInList) {
          this.selectedProcessParticipator.respondents.push({ id: item.id, name: item.name });
        }
      });
    }

    private getAppraiseeById(id: number) {
      return this._processParticipators
        .find(pp => pp.processDurationAppraiseeId === id);
    }
}